import { render, staticRenderFns } from "./siswaTerdaftar.vue?vue&type=template&id=29053e12"
import script from "./siswaTerdaftar.vue?vue&type=script&lang=js"
export * from "./siswaTerdaftar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports